import React, { useState } from 'react';
import { TextToolTip } from 'components';
import { Images } from 'utils';
import { APPT_PREVIEW_COUNT, APPT_TABLE_COLUMNS } from './constants';

export const ApptTable = ({ appointments = [] }) => {
    const [expanded, setExpanded] = useState(false);

    const hiddenCount = appointments.length - APPT_PREVIEW_COUNT;
    const visibleAppts = expanded ? appointments : appointments.slice(0, APPT_PREVIEW_COUNT);

    return (
        <div className="signature-request-appts">
            <p className="signature-request-appts-title">Appointments ({appointments.length})</p>

            <table className="signature-request-appts-table">
                <thead>
                    <tr>
                        {APPT_TABLE_COLUMNS.map((column) => (
                            <th key={column.key}>
                                <TextToolTip
                                    classNameWrapper={'signature-request-appts-head-wrap'}
                                    classNameText={'signature-request-appts-head'}
                                    text={column.title}
                                    content={column.title}
                                />
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {visibleAppts.map((appt, index) => (
                        <tr key={appt?.id ?? index}>
                            {APPT_TABLE_COLUMNS.map((column) => (
                                <td key={column.key}>{column.render?.(appt)}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            {hiddenCount > 0 && (
                <button type="button" className="signature-request-show-more" onClick={() => setExpanded((prev) => !prev)}>
                    {expanded ? 'Show less' : `+ Show ${hiddenCount} more appointments`}
                    <img className={expanded ? 'rotated' : ''} src={Images.chevronDown} alt="toggle" />
                </button>
            )}
        </div>
    );
};
